module.exports = __webpack_public_path__ + "static/media/sws-image.f71b93b9.svg";